export default "<g id=\"triangle-down\">\n    <path id=\"Path 51\" d=\"M2 7L12 17L22 7H2Z\"/>\n</g>";